var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.communityBand'] = (function () {
    'use strict';

    const initialize = (widget) => {
        const carouselEl = widget.querySelector(".splide");
        if (carouselEl) carousel(widget, carouselEl);

        const toggleButton = widget.querySelector('button.community-band-rotation-toggle');
        let isPaused = false;

        const syncButtonUi = () => {
            toggleButton.setAttribute('aria-pressed', String(isPaused));
            toggleButton.querySelector(".fa").classList.remove('fa-pause', 'fa-play');
            toggleButton.querySelector(".fa").classList.add(isPaused ? 'fa-play' : 'fa-pause');
            toggleButton.querySelector(".sr-only").textContent = isPaused ? 'Resume image carousel' : 'Pause image carousel';
        };

        if (toggleButton) {
            toggleButton.addEventListener('click', () => {
                isPaused = !isPaused;

                syncButtonUi();
            });

            syncButtonUi();
        }
    };

    const carousel = (widget, carousel) => {
        const splideOptions = {
            pagination: false,
            type: 'loop',
            fixedWidth: "320px",
            gap: "35px",
            drag: false,
            snap: false,
            perMove: 1,
            autoScroll: {
                speed: 1,
                pauseOnHover: false
            },
            breakpoints: {
                991: {
                    fixedWidth: "175px",
                    gap: "15px",
                },
            }
        };

        App.Helpers.splideFallback(
            carousel,
            splideOptions,
            function (splide) {
                splideEventBindings(widget, carousel, splideOptions);
            }
        );
    }

    const splideEventBindings = (widget, carousel, splideOptions) => {
        const splide = new Splide(carousel, splideOptions);
        const autoScroll = window.splide?.Extensions?.AutoScroll;
        splide.mount(autoScroll ? { AutoScroll: autoScroll } : undefined);

        const splideControl = widget.querySelectorAll("button.community-band-rotation-toggle");
        splideControl.forEach(button => {
            button.addEventListener("click", function () {
                const autoScrollComponent = splide.Components?.AutoScroll;
                if (autoScrollComponent.isPaused()) {
                    autoScrollComponent.play();
                } else {
                    autoScrollComponent.pause();
                }
            });
        });
    }

    return {
        initialize
    };

})();